import { useContext, useMemo } from "react";
import { useAuth } from "react-oidc-context";

import { modalButtonDisplay } from "../../constants";
import { SiteContext } from "../../contexts/siteContext";
import { UserDataContext } from "../../contexts/userDataContext";
import { getIsSysAdmin, isRoutePermitted } from "../../utils";
import { DataTableRowButton, DataTableRowCell } from "../";
import { useDataTableContext } from "./hooks/useDataTableContext";

export const DataTableRow = ({ row, prepareRow, index }) => {
	const {
		setOrgModalAction,
		isSelect,
		setInitialModalData,
		dataTableEditorSettings,
	} = useDataTableContext();
	const { selectedOrg } = useContext(UserDataContext);
	const { selectedSite } = useContext(SiteContext);

	const { isAuthenticated } = useAuth();
	const isSysAdmin = useMemo(getIsSysAdmin, [isAuthenticated]);

	prepareRow(row);

	// react-table's getRowProps/getCellProps include a `key`; destructure it
	// so it is passed to JSX directly instead of spread (React warns on the
	// latter).
	const { key: rowKey, ...rowProps } = row.getRowProps();

	const openModalWithData = (action) => () => {
		setInitialModalData([JSON.parse(JSON.stringify(row.original))]);
		setOrgModalAction(action);
	};

	const dropDownButtons = useMemo(
		() =>
			dataTableEditorSettings?.actions
				.filter(
					({ display, isVisibleFn, permissions }) =>
						display === modalButtonDisplay.INLINE &&
						(!isVisibleFn || isVisibleFn(row.original)) &&
						isRoutePermitted(
							{
								...selectedOrg.permissions,
								...selectedSite.permissions,
							},
							permissions,
							isSysAdmin
						)
				)
				.map((actionData, index) => (
					<DataTableRowButton
						key={`dtRowButton-${index}`}
						actionData={actionData}
						onClick={openModalWithData(actionData.action)}
					/>
				)),
		[dataTableEditorSettings, row, selectedOrg.id]
	);

	return (
		<tr
			key={rowKey ?? `r-${index}`}
			data-testid="test-dataTableRow"
			className={row.isSelected ? "selected" : ""}
			{...rowProps}
		>
			{row.cells.map((cell, index) => {
				const { key: cellKey, ...cellProps } = cell.getCellProps([
					{
						className: cell.column.className, // pay attention to this
						style: cell.column.style, // set here your other custom props
					},
				]);
				return (
					<td
						style={
							index === 0 && isSelect
								? {
										MozUserSelect: "none",
										WebkitUserSelect: "none",
										msUserSelect: "none",
								  }
								: {}
						}
						onClick={() => {
							if (index === 0 && isSelect)
								row?.toggleRowSelected &&
									row.toggleRowSelected({
										isSelected: !row.isSelected,
										method: "row",
									});
						}}
						key={cellKey ?? `cell1-${index}`}
						{...cellProps}
					>
						<DataTableRowCell
							key={`cell2-${index}`}
							{...{ ...cell, dropDownButtons }}
						/>
					</td>
				);
			})}
		</tr>
	);
};

// onClick={() =>
// 	row?.toggleRowSelected &&
// 	row.toggleRowSelected({
// 		isSelected: !row.isSelected,
// 		method: "row",
// 	})
// }
